import clsx from "clsx";
import React, { FC } from "react";

const ActionIconButton: FC<{ toggleClick: (e) => void; type: string }> = ({
  toggleClick,
  type,
}) => {
  return (
    <button
      onClick={toggleClick}
      className={clsx("button hard", {
        "btn-close": type === "close",
        "btn-back": type === "back",
        "btn-close btn-close-notif": type === "close-notif",
      })}
    />
  );
};

export default ActionIconButton;
